// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"123":"80be0e53","320":"9196fad0","450":"355a5eae","720":"18fcb0b1","893":"5dd75de1"}[chunkId] + ".chunk.js";
};